import { render, staticRenderFns } from "./DealRedeemDialog.vue?vue&type=template&id=75275538&"
import script from "./DealRedeemDialog.vue?vue&type=script&lang=ts&"
export * from "./DealRedeemDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DealRedeemDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardActions,VCardSubtitle,VCardText,VCardTitle,VImg,VTextField})
